import React from 'react';
import { connect } from 'react-redux';
import styled from 'styled-components';
import { get } from 'lodash';

import PropTypes from 'prop-types';

import Bubble, { BubbleTypes } from '../../components/bubble';

const Container = styled.div`
    display: flex;
    flex-wrap: wrap;

    & > div {
        margin-right: 32px;
        margin-bottom: 32px;
    }

    @media (max-width: 767px) {
        & > div {
            margin-right: 16px;
            margin-bottom: 16px;
        }
    }
`;

export const CorrectionBubbles = ({ exercisesCorrection, selectedBubble, onClick }) => {
    return (
        <Container>
            {get(exercisesCorrection, BubbleTypes.correct) > 0 && (
                <Bubble
                    isSelected={selectedBubble === BubbleTypes.correct}
                    type={BubbleTypes.correct}
                    number={get(exercisesCorrection, BubbleTypes.correct)}
                    description="Esatti"
                    onClick={onClick}
                />
            )}
            {(get(exercisesCorrection, BubbleTypes.wrong) > 0 || get(exercisesCorrection, BubbleTypes.incomplete) > 0) && (
                <Bubble
                    isSelected={selectedBubble === BubbleTypes.wrong}
                    type={BubbleTypes.wrong}
                    number={get(exercisesCorrection, BubbleTypes.wrong) + get(exercisesCorrection, BubbleTypes.incomplete)}
                    description="Sbagliati o con errori"
                    onClick={onClick}
                />
            )}
            {get(exercisesCorrection, BubbleTypes.waiting) > 0 && (
                <Bubble
                    isSelected={selectedBubble === BubbleTypes.waiting}
                    type={BubbleTypes.waiting}
                    number={get(exercisesCorrection, BubbleTypes.waiting)}
                    description="Riposta aperta"
                    onClick={onClick}
                />
            )}
            {get(exercisesCorrection, BubbleTypes.missing) > 0 && (
                <Bubble
                    isSelected={selectedBubble === BubbleTypes.missing}
                    type={BubbleTypes.missing}
                    number={get(exercisesCorrection, BubbleTypes.missing)}
                    description="Non svolti"
                    onClick={onClick}
                />
            )}
        </Container>
    );
};

CorrectionBubbles.propTypes = {
    exercisesCorrection: PropTypes.object,
    selectedBubble: PropTypes.string,
    onClick: PropTypes.func,
};

const mapStateToProps = (state) => {
    return {
        exercisesCorrection: state.status.exercisesCorrection,
    };
};

export default connect(mapStateToProps)(CorrectionBubbles);
